import React from "react";
import {
  Badge,
  Box,
  List,
  ListItem,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { FlagIcon } from "../utils/FlagIcon";

interface MarketplaceTileProps {
  marketplaces: Map<string, number>;
}

const MarketplaceTile: React.FC<MarketplaceTileProps> = ({ marketplaces }) => {
  const marketplace_list = Array.from(marketplaces.keys());
  const rowCount = Math.ceil(marketplace_list.length / 3); // three columns

  return (
    <Paper elevation={3} sx={{ padding: 1, marginBottom: 1 }}>
      <List>
        {Array.from({ length: rowCount }).map((_, rowIndex) => (
          <ListItem key={rowIndex} disablePadding>
            <Grid container spacing={2}>
              {[0, 1, 2].map((colIndex) => {
                const itemIndex = rowIndex * 3 + colIndex;
                if (itemIndex < marketplace_list.length) {
                  return (
                    <Grid item xs={4} key={colIndex}>
                      <Box display={"flex"} alignItems={"center"}>
                        <Typography sx={{ mr: 1 }}>
                          {" "}
                          <Badge
                            badgeContent={
                              marketplaces.get(marketplace_list[itemIndex])! > 1
                                ? marketplaces.get(marketplace_list[itemIndex])
                                : 0
                            }
                            color={"primary"}
                          >
                            {FlagIcon(marketplace_list[itemIndex])}
                          </Badge>
                        </Typography>
                        <Typography>{marketplace_list[itemIndex]}</Typography>
                      </Box>
                    </Grid>
                  );
                }
                return <Grid item xs={4} key={colIndex} />;
              })}
            </Grid>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default MarketplaceTile;
